import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schedule-entries--week-calendar"

export default class extends Controller {
  static targets = ["label", "headerRow", "searchWeekStart", "searchForm"]

  connect() {
    this.updateWeekLabel(this.getCurrentWeekStart())
  }

  prev(event) {
    event.preventDefault()
    this.navigateWeek(-7)
    this.activeWeekStartButton(event)
  }

  today(event) {
    event.preventDefault()
    const today = new Date()
    const weekStart = this.getWeekStart(today)
    this.loadWeek(weekStart)
    this.activeWeekStartButton(event)
  }

  next(event) {
    event.preventDefault()
    this.navigateWeek(7)
    this.activeWeekStartButton(event)
  }

  navigateWeek(days) {
    const currentStart = this.getCurrentWeekStart()
    const newStart = new Date(currentStart)
    newStart.setDate(newStart.getDate() + days)
    this.loadWeek(newStart)
  }

  loadWeek(weekStart) {
    const dateStr = weekStart.toISOString().split('T')[0]
    this.updateWeekLabel(new Date(weekStart))
    this.searchWeekStartTarget.value = dateStr;
    this.searchFormTarget.requestSubmit();
  }

  getCurrentWeekStart() {
    const firstDateCell = this.headerRowTarget.querySelector('th[data-date]')
    if (firstDateCell) {
      return new Date(firstDateCell.dataset.date)
    }
    return this.getWeekStart(new Date())
  }

  getWeekStart(date) {
    const d = new Date(date)
    const day = d.getDay()
    const diff = d.getDate() - day + (day === 0 ? -6 : 1)
    return new Date(d.setDate(diff))
  }

  updateWeekLabel(weekStart) {
    const lastDate = new Date(weekStart)
    lastDate.setDate(weekStart.getDate() + 6)
    this.labelTarget.textContent = `${weekStart.getFullYear()}年 ${weekStart.getMonth() + 1}月${weekStart.getDate()}日 〜 ${lastDate.getFullYear()}年 ${lastDate.getMonth() + 1}月${lastDate.getDate()}日`
  }

  triggerSubmitSearchForm(event) {
    event.currentTarget.closest("form").requestSubmit();
  }

  getSearchFormParams() {
    if (!this.hasSearchFormTarget) return new URLSearchParams();
    return new URLSearchParams(new FormData(this.searchFormTarget));
  }

  activeWeekStartButton(event) {
    this.element.querySelectorAll('.active').forEach(b => b.classList.remove('active'))
    this.element.querySelectorAll(".schedule-page__toolbar .btn")
      .forEach(btn => btn.classList.remove("active"))
    event.currentTarget.classList.add("active")
  }
}
